import { css, Theme } from '@emotion/react'

import { border } from '@arcade/web'

import { ListOrderedTypes } from '../components'

export const getStandardNumberStyles = (theme: Theme) => css`
  ${theme.typography.label}
  background-color: ${theme.arcadeColors.semantic.iconStandard};
  color: ${theme.colors.textInverse};
  min-width: ${theme.pxToRem(24)};
  height: ${theme.pxToRem(24)};
  border-radius: ${border.radius.circle};
`

export const getSubtleNumberStyles = (theme: Theme) => css`
  ${theme.typography.label}
  background-color: ${theme.arcadeColors.semantic.backgroundSubtle};
  color: ${theme.colors.textSubtle};
  min-width: ${theme.pxToRem(24)};
  height: ${theme.pxToRem(24)};
  border-radius: ${border.radius.circle};
  align-self: start;
`

export const getItemContentStyles = (theme: Theme, type: ListOrderedTypes = 'standard') => css`
  ${theme.typography.body}
  color: ${type === 'standard' ? theme.colors.textStandard : theme.colors.textSubtle};
`
